export const getQueryParams = (search) => {
    const params = new URLSearchParams(search);
    const queryObject = {};
    for (const [key, value] of params.entries()) {
      queryObject[key] = value;
    }
    return queryObject;
  };